import { h } from "preact";
import { RoutableProps } from "preact-router";
import { useEffect, useState } from "preact/hooks";
import { editLabel, getLabels, Label } from "../../../api/product-api";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand, useForceUpdate } from "../../../hooks";
import { parseToDateAndFormatIfExists } from "../../../utils";
import { SelectableList, SelectableListItem } from "../../../components/SelectableList";
import { route } from "../../../App";
import { generateDownloadZip, generateLabelInfo } from "../utils";

import "./styles.scss";
import { countries } from "../../../data/countries";

export function LabelHomePage(props: RoutableProps) {
    const [labels, setLabels] = useState(null as null | Label[]);
    const [filteredLabels, setFilteredLabels] = useState([] as Label[]);
    const [actionProgress, setActionProgress] = useState(null as null | number);
    const [labelsSearch, setLabelsSearch] = useState(localStorage.getItem("label-metadata-search") ?? "");
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(100);
    const [selectedLabels, setSelectedLabels] = useState([] as readonly Label[]);
    const [lastSelectedLabelIndex, setLastSelectedLabelIndex] = useState(null as number | null);
    const showSnackbarCommand = useCommand<SnackbarShowCommand>();
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        getLabels().then(async labels => {
            setLabels(labels);
            setFilteredLabels(labels);
        });
    }, [page, count, refresh]);

    useEffect(() => {
        setLastSelectedLabelIndex(null);
    }, [filteredLabels]);

    useEffect(() => {
        if (labels) {
            setFilteredLabels(
                labels.filter(
                    item =>
                        !labelsSearch ||
                        item.name.toLowerCase().indexOf(labelsSearch.toLowerCase()) >= 0 ||
                        item.path.toLowerCase().indexOf(labelsSearch.toLowerCase()) >= 0 ||
                        item.creator.email.toLowerCase().indexOf(labelsSearch.toLowerCase()) >= 0 ||
                        parseToDateAndFormatIfExists(item.createdAt).toLocaleString().indexOf(labelsSearch) >= 0,
                ),
            );
        } else {
            setFilteredLabels([]);
        }
    }, [labels, labelsSearch]);

    if (!labels) {
        return (
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
                <div>Pobieranie danych...</div>
                <div class="loader"></div>
            </div>
        );
    }

    return (
        <div class="label-home-page">
            <Snackbar doShow={showSnackbarCommand} />
            {labels
                ? [
                      <h1>Naklejki</h1>,
                      <div class="order-items paper">
                          <div class="search">
                              <input
                                  class="search-text"
                                  placeholder="Wyszukaj..."
                                  value={labelsSearch}
                                  onInput={e => {
                                      setLabelsSearch(e.currentTarget.value);
                                      localStorage.setItem("label-metadata-search", e.currentTarget.value);
                                  }}
                              />
                              <button type="button" onClick={() => route("/label/new")} style="margin-left: 10px;">
                                  Utwórz naklejkę
                              </button>
                          </div>
                          {/* <div>
                    <button type="button" class={page <= 0 ? "disabled" : ""} onClick={() => setPage(page - 1)}>Poprzednia strona</button>
                    <button type="button" onClick={() => setPage(page + 1)}>Następna strona</button>
                    <input type="number" value={count} onChange={(e) => setCount(+e.currentTarget.value)}/>
                </div> */}
                          <div class="actions" style="margin-bottom: 10px; display: flex; align-items: center">
                              {selectedLabels.length > 0
                                  ? [
                                        <button
                                            type="button"
                                            class="icon flat"
                                            data-tooltip="Odznacz wszystkie"
                                            onClick={() => {
                                                setSelectedLabels([]);
                                            }}
                                        >
                                            remove
                                        </button>,
                                        <button
                                            type="button"
                                            style="margin-left: 10px;"
                                            data-tooltip="Pobierz w formacie PNG"
                                            onClick={async () => {
                                                await generateDownloadZip(
                                                    selectedLabels,
                                                    v => setActionProgress(v),
                                                    "png",
                                                );
                                            }}
                                        >
                                            PNG
                                        </button>,
                                        <button
                                            type="button"
                                            style="margin-left: 10px;"
                                            data-tooltip="Pobierz w formacie SVG"
                                            onClick={async () => {
                                                await generateDownloadZip(
                                                    selectedLabels,
                                                    v => setActionProgress(v),
                                                    "svg",
                                                );
                                            }}
                                        >
                                            SVG
                                        </button>,
                                        <button
                                            type="button"
                                            style="margin-left: 10px;"
                                            data-tooltip="Pobierz w formacie PDF"
                                            onClick={async () => {
                                                await generateDownloadZip(
                                                    selectedLabels,
                                                    v => setActionProgress(v),
                                                    "pdf-separate",
                                                );
                                            }}
                                        >
                                            PDF
                                        </button>,
                                        <button
                                            type="button"
                                            style="margin-left: 10px;"
                                            data-tooltip="Pobierz w formacie PDF scalone w jednym pliku"
                                            onClick={async () => {
                                                await generateDownloadZip(
                                                    selectedLabels,
                                                    v => setActionProgress(v),
                                                    "pdf",
                                                );
                                            }}
                                        >
                                            Zbiorczy PDF
                                        </button>,
                                    ]
                                  : [
                                        <button
                                            type="button"
                                            class="icon flat"
                                            data-tooltip="Zaznacz wszystkie"
                                            onClick={() => {
                                                setSelectedLabels(filteredLabels);
                                            }}
                                        >
                                            check_box_outline_blank
                                        </button>,
                                    ]}
                              <div style="flex: 1 1;" />
                              {actionProgress !== null ? (
                                  <progress min={0} max={100} value={actionProgress * 100} />
                              ) : null}
                          </div>

                          <SelectableList
                              items={filteredLabels}
                              value={selectedLabels}
                              onChange={items => {
                                  setSelectedLabels(items);
                              }}
                          >
                              <table class="orders list secondary" style="margin-bottom: 10px; user-select: none">
                                  <thead>
                                      <tr>
                                          <th class="header"></th>
                                          <th class="header">Id</th>
                                          <th class="header">Nazwa</th>
                                          <th class="header">Rewizja</th>
                                          <th class="header">Ścieżka</th>
                                          <th class="header">Szablon</th>
                                          <th class="header">Rejestrujący</th>
                                          <th class="header">Data rejestracji</th>
                                          <th class="header">Kraj</th>
                                          <th class="header">Zarchiwizowane</th>
                                          <th class="header">Info</th>
                                          <th class="header">Akcje</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {filteredLabels.map(item => (
                                          <SelectableListItem item={item}>
                                              {selectableController => (
                                                  <tr
                                                      class={
                                                          "item" +
                                                          (selectableController.isSelected(item) ? " selected" : "")
                                                      }
                                                      onClick={e => {
                                                          route(
                                                              item.parentLabel
                                                                  ? `/label/${item.id}`
                                                                  : `/label/edit-old/${item.id}`,
                                                          );
                                                      }}
                                                  >
                                                      <td
                                                          onClick={e => {
                                                              selectableController.select(item, true, e.shiftKey);
                                                              e.preventDefault();
                                                              e.stopPropagation();
                                                          }}
                                                      >
                                                          <input
                                                              type="checkbox"
                                                              class="tooltip"
                                                              data-tooltip="Zaznacz/Odznacz"
                                                              checked={selectableController.isSelected(item)}
                                                          />
                                                      </td>
                                                      <td>{item.id}</td>
                                                      <td>{item.name}</td>
                                                      <td>{item.revision}</td>
                                                      <td>{item.path}</td>
                                                      <td>{item.parentLabel?.name}</td>
                                                      <td>{item.creator.email}</td>
                                                      <td>{parseToDateAndFormatIfExists(item.createdAt)}</td>
                                                      <td>
                                                          {item.metadata?.metadata?.country
                                                              ? countries[
                                                                    item.metadata.metadata
                                                                        .country as keyof typeof countries
                                                                ]
                                                              : "Standardowe"}
                                                          {item.metadata?.metadata?.country
                                                              ? ` (${item.metadata.metadata.country})`
                                                              : ""}
                                                      </td>
                                                      <td>{item.description.includes("(archived)") ? "Tak" : "Nie"}</td>
                                                      <td class="text-center">
                                                          {item.metadata?.metadata ? (
                                                              <span
                                                                  class="icon tooltip tooltip-pre"
                                                                  data-tooltip={generateLabelInfo(item)}
                                                              >
                                                                  info
                                                              </span>
                                                          ) : null}
                                                      </td>
                                                      <td class="text-center whitespace-nowrap">
                                                          {!item.description.includes("(archived)") && (
                                                              <button
                                                                  type="button"
                                                                  data-tooltip="Archiwizuj"
                                                                  class="icon borderless flat"
                                                                  onClick={async e => {
                                                                      e.preventDefault();
                                                                      e.stopPropagation();

                                                                      await editLabel({
                                                                          ...item,
                                                                          description: "(archived)",
                                                                      }).catch(e => {
                                                                          showSnackbarCommand.run(
                                                                              "Błąd podczas archiwizacji naklejki: " +
                                                                                  e.message,
                                                                              "error",
                                                                              "error",
                                                                              2000,
                                                                          );
                                                                      });

                                                                      setRefresh(prev => prev + 1);
                                                                  }}
                                                              >
                                                                  archive
                                                              </button>
                                                          )}
                                                          {item.description.includes("(archived)") && (
                                                              <button
                                                                  type="button"
                                                                  data-tooltip="Przywróc"
                                                                  class="icon borderless flat"
                                                                  onClick={async e => {
                                                                      e.preventDefault();
                                                                      e.stopPropagation();

                                                                      await editLabel({
                                                                          ...item,
                                                                          description: "",
                                                                      }).catch(e => {
                                                                          showSnackbarCommand.run(
                                                                              "Błąd podczas przywracania naklejki: " +
                                                                                  e.message,
                                                                              "error",
                                                                              "error",
                                                                              2000,
                                                                          );
                                                                      });

                                                                      setRefresh(prev => prev + 1);
                                                                  }}
                                                              >
                                                                  unarchive
                                                              </button>
                                                          )}
                                                          <button
                                                              type="button"
                                                              data-tooltip="Szczegóły..."
                                                              class="icon borderless flat"
                                                              onClick={() =>
                                                                  route(
                                                                      item.parentLabel
                                                                          ? `/label/${item.id}`
                                                                          : `/label/edit-old/${item.id}`,
                                                                  )
                                                              }
                                                          >
                                                              chevron_right
                                                          </button>
                                                      </td>
                                                  </tr>
                                              )}
                                          </SelectableListItem>
                                      ))}
                                  </tbody>
                              </table>
                          </SelectableList>
                      </div>,
                  ]
                : null}
        </div>
    );
}
